module.exports = __webpack_public_path__ + "static/media/cartes-bancaires.f4ce1e96.svg";